<template>
  <v-layout wrap>
    <v-snackbar v-model="snackbar" color="#FEBD08" :timeout="timeout">
      <v-layout wrap>
        <v-flex xs11> Incorrect Email or Password..!! </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-flex xs6 class="hidden-sm-and-down">
      <v-img
        class="white--text align-end"
        height="100vh"
        :style="
          $vuetify.breakpoint.name == 'md' ? 'height:50vh' : 'height=100vh'
        "
        src="../../assets/images/login4.jpg"
      >
        <v-layout wrap>
          <v-flex xs12 pb-3>
            <span
              style="
                font-family: Times New Roman;
                font-size: 50px;
                padding-left: 8%;
              "
            >
              Direct from </span
            ><span style="font-family: blackbold; font-size: 50px">
              Hivekeepers.</span
            >
            <br />
            <span
              style="
                font-family: robotolight;
                line-height: 0.9;
                padding-left: 8%;
                font-size: 30px;
              "
              >A Good Source of antioxidants</span
            >
          </v-flex>
        </v-layout>
      </v-img>
    </v-flex>
    <v-flex xs12 md6 align-self-center text-center>
      <v-layout wrap justify-center py-5 py-sm-12 py-md-0>
        <v-flex xs12 sm7 px-2 md10 lg6>
          <v-form ref="form">
            <v-layout wrap>
              <v-flex xs12 style="font: 30px robotomedium" pb-5 pb-lg-12>
               
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :rules="[rules.email]"
                  label="Email"
                  class="textfd"
                  v-model="email"
                  outlined
                  dense
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :rules="[rules.required]"
                  v-model="password"
                  style="height: 45px"
                  label="Password"
                  class="textfd"
                  dense
                  outlined
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                
                >
                </v-text-field>
              </v-flex>
              <!-- <v-flex xs12>
                <v-checkbox label="Keep me sign in"> </v-checkbox>
              </v-flex> -->
              <v-flex xs12 pt-5>
                <v-btn
                
                  @click="uploadData"
                  width="100%"
                  color="#FEBD08"
                  tile
                  style="color: white"
                >
                  SIGN IN
                </v-btn>
              </v-flex>
              <v-flex xs12 py-2 pt-lg-5 class="regular">
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'signup' }"
                >
                  Create Customer Account
                </router-link>
              </v-flex>
              <v-flex xs12 pb-5 class="regular">
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'sellersignup' }"
                >
                  Create Seller Account
                </router-link>
              </v-flex>
              <v-flex xs12 class="regular">
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'changePassword' }"
                >
                  Forget your Password..? 
                </router-link>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="hidden-xs-only hidden-lg-and-up" style="height: 150px">
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import store from "../../store";
export default {
  data() {
    return {

 location:null,
    gettingLocation: false,
    errorStr:null,
      timeout:5000,
      snackbar: false,
      msg: false,
      email: "",
      password: "",
      showPassword: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  mounted()
  {
    this.loaction()

  },
  methods: {
    uploadData() {
      if (this.$refs.form.validate()) {
        axios({
          method: "POST",
          url: "/web/user/login",
          data: {
            username: this.email,
            password: this.password,
          },
        }).then((response) => {
          if (response.data.status) {
            store.commit("loginUser", response.data.data);
            store.commit("userData", response.data.data);
            // setTimeout( () => this.$router.push({ path: '/login'}), 2000);
            console.log(response.data.data);
            // alert("success")
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        });
      }
    },
    loaction()
    {
       navigator.geolocation.getCurrentPosition(pos => {
      this.gettingLocation = false;
      this.location = pos;
      console.log("your location iss=",this.location)
    }
    , err => {
      this.gettingLocation = false;
      this.errorStr = err.message;
    })
    }

  },
};
</script>